const ITEMS = [
  "Fleet Partner Program",
  "Premium Jet Car Experiences",
  "Performance-Based Revenue Share",
  "Fleet · Maintenance · Training · Marketing",
  "We bring the Jet Cars — you bring the waterfront",
  "Nationwide Expansion Review",
];

export const Marquee = () => (
  <div className="overflow-hidden border-y border-black/[0.06] bg-charcoal/40 py-5" aria-hidden="true">
    <div className="flex w-max animate-marquee gap-0 hover:[animation-play-state:paused]">
      {[0, 1].map((copy) => (
        <div key={copy} className="flex shrink-0 items-center">
          {ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-display text-xs font-bold uppercase tracking-[0.3em] text-muted">
                {item}
              </span>
              <span className="h-1.5 w-1.5 rotate-45 bg-aqua/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
